/**
 * Created by swandelow on 16/01/17.
 */
angular.module('CarsSaraBo').factory('GeoService', ['$http', function ($http) {
    function getData(url, nameLike, language) {
        var config = {
            params: {
                nameLike: nameLike,
                language: language
            }
        };
        return $http.get(url, config);
    }

    return {

        getCountries: function () {
            return $http.get("../rest/geo/countries");
        },

        getAirportsAndCities: function (nameLike, language) {
            return getData("../rest/geo/airportsAndCities", nameLike, language);
        },

        /*
        * Se agrega este método para evitar problemas de encoding y eliminar código duplicado.(SARA-701)
        *
        * TODO: REVISAR DIFERENCIA CON getAirportsAndCities()
        * */
        search: function (nameLike, language) {
            return getData("../rest/geo/search", nameLike, language);
        },

        getCities: function(nameLike, language) {
            return getData("../rest/geo/cities", nameLike, language);
        }
    }
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/geo_service.js
// module id = 849
// module chunks = 3